
  import { mapState } from 'vuex'

  import HorizontalCarousel from '@loavies/component-library/dist/horizontal-carousel'

  export default {
    name: 'FaqPage',
    components: {
      HorizontalCarousel,
    },
    async asyncData(context) {
      try {
        return await context.$datoApiService.getPageData(context.route)
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Error while retrieving data:', error)
        }

        return context.error({ statusCode: 404, message: 'Not found.' })
      }
    },
    head() {
      return {
        title: this.$pageHelperService.getFormattedPageTitle(this.$t('frequently_asked_questions')),
      }
    },
    computed: {
      ...mapState({
        user: state => state.user.user,
        isMobile: state => state.isMobile,
      }),
      categories() {
        return this.page.categories
      },
      contactOptions() {
        return this.page.contactOptions
      },
      displayedFirstname() {
        return this.user?.firstName ? ' ' + this.user.firstName : ''
      },
      defaultActiveCategory() {
        return this.page.defaultActiveCategory
      },
      activeCategory() {
        const { tab } = this.$route.query

        return this.categories.find(category => category.tabName === tab)
          ?? this.defaultActiveCategory
          ?? this.categories[0]
      },
      questions() {
        return this.activeCategory.questions ?? []
      },
    },
    mounted() {
      this.scrollToActiveTab()
    },
    methods: {
      isActiveCategory(category) {
        return category?.tabName === this.activeCategory?.tabName
      },
      async scrollToActiveTab() {
        const { tab } = this.$route.query

        if (!tab) return

        await this.$nextTick()
        const element = this.$refs[tab]?.$el

        if (!element) return

        element.scrollIntoView({ block: 'nearest' })
      },
    },
  }
